import type { ArchbaseRemoteApiClient } from '@archbase/data';
import { injectable, inject } from 'inversify';
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core';
import type { OptimizeResponse, RouteJobDto, PageResponse } from '@domain/routeJob/RouteJobDto';

const BASE = '/api/v1/routes';

@injectable()
export class RouteXRouteJobService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  async findAll(page = 0, size = 20): Promise<PageResponse<RouteJobDto>> {
    return this.client.get(`${BASE}?page=${page}&size=${size}`);
  }

  async getJobResult(jobId: string): Promise<OptimizeResponse> {
    return this.client.get(`${BASE}/${jobId}`);
  }
}
